import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { PRIMARY_PHONE, SITE } from "@/lib/site";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <header
      data-testid="site-header"
      className="glass-header sticky top-0 z-50 w-full"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center gap-2 group"
          onClick={() => setOpen(false)}
        >
          <div className="grid h-9 w-9 place-items-center rounded-md bg-[var(--color-primary)] text-white font-display font-black text-sm tracking-tighter">
            VW
          </div>
          <div className="leading-tight">
            <div className="font-display font-extrabold text-[15px] text-slate-900">
              Vic Wide Towing
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">
              24/7 · Victoria, AU
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-semibold rounded-md transition-colors ${
                  isActive
                    ? "text-[var(--color-primary)] bg-blue-50"
                    : "text-slate-700 hover:text-[var(--color-primary)] hover:bg-slate-50"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={`tel:${PRIMARY_PHONE.tel}`}
            data-testid="header-call-now-button"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[var(--color-secondary)] px-4 py-2 text-sm font-bold text-white shadow-sm transition-all hover:bg-[var(--color-secondary-soft)] hover:-translate-y-0.5 hover:shadow-md"
          >
            <Phone className="h-4 w-4" />
            <span className="font-num">{PRIMARY_PHONE.number}</span>
          </a>
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            data-testid="header-mobile-toggle"
            aria-label="Toggle menu"
            className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-md border border-slate-200 bg-white text-slate-900 hover:bg-slate-50"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-nav-panel"
          className="lg:hidden border-t border-slate-200 bg-white/95 backdrop-blur"
        >
          <nav className="mx-auto max-w-7xl px-4 py-4 space-y-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `block px-3 py-2 rounded-md text-base font-semibold ${
                    isActive
                      ? "text-[var(--color-primary)] bg-blue-50"
                      : "text-slate-800 hover:bg-slate-50"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <a
              href={`tel:${PRIMARY_PHONE.tel}`}
              data-testid="mobile-nav-call-button"
              className="mt-2 flex items-center justify-center gap-2 rounded-full bg-[var(--color-secondary)] px-4 py-3 text-base font-bold text-white"
            >
              <Phone className="h-4 w-4" />
              Call {PRIMARY_PHONE.number}
            </a>
            <p className="text-center text-xs text-slate-500 pt-1">
              {SITE.availability}
            </p>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
